import { useEffect, useRef } from "react";

import { acaoEntregar } from "../lib/acoes";
import { montarGarcom, pratosParaLevar } from "../lib/garcom";
import { tocarPratoPronto } from "../lib/somGarcom";

/** Ações e alerta da tela do Garçom.
 *
 *  Entregar grava `entregue` no item (o servidor marca pronto junto se faltar)
 *  e NÃO mexe no status do pedido: quem fecha e cobra a mesa é o caixa. A
 *  gravação passa pelo `agendar` do Desfazer (hooks/useDesfazer.js).
 *
 *  O som toca quando o número de pratos esperando SOBE — uma vez por prato
 *  novo. Na primeira leitura só registra o número, senão abrir a tela com
 *  três pratos parados tocaria na hora. `pedidos` aqui é a fila DO SERVIDOR,
 *  sem a ação em espera deste aparelho: desfazer uma entrega não é prato novo.
 */
export default function useGarcom({ ativo, pedidos, agendar }) {
  const anteriorRef = useRef(null);
  const { paraLevar } = montarGarcom(pedidos);
  const esperando = pratosParaLevar(paraLevar);

  useEffect(() => {
    if (!ativo) { anteriorRef.current = null; return; }
    if (anteriorRef.current !== null && esperando > anteriorRef.current) tocarPratoPronto();
    anteriorRef.current = esperando;
  }, [ativo, esperando]);

  const entregar = (pedido, item, entregue = true) => agendar(acaoEntregar(pedido, [item], entregue));

  /** `opcoes.daCozinha`: o "Entregue na mesa" do cartão de Prontos da cozinha. */
  const entregarTudo = (pedido, itens, opcoes) => (itens.length ? agendar(acaoEntregar(pedido, itens, true, opcoes)) : undefined);

  return { entregar, entregarTudo, esperando };
}
